"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HLQATasksWidget = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_router_1 = require("react-router");
const client_1 = require("./client");
const utils_1 = require("./client/utils");
const components_1 = require("./components");
const hlqa_tasks_widget_styles_1 = require("./hlqa-tasks-widget.styles");
const table_config_1 = require("./hooks/table-config");
const constants_1 = require("./hooks/table-config/constants");
const use_columns_order_1 = require("./hooks/use-columns-order");
const use_dashboard_tasks_query_params_sync_1 = require("./hooks/use-dashboard-tasks-query-params-sync");
const use_hlqa_tasks_bulk_actions_hook_1 = require("./hooks/use-hlqa-tasks-bulk-actions.hook");
const use_process_row_update_hook_1 = require("./hooks/use-process-row-update.hook");
const client_constants_1 = require("../../client/client.constants");
const query_params_1 = require("../../hooks/query-params");
const table_error_overlay_1 = require("../../common/table-error-overlay");
const table_filter_1 = require("../../common/table-filter");
const table_pagination_1 = require("../../common/table-pagination");
const use_table_loading_state_1 = require("../../common/use-table-loading-state");
const dashboards_1 = require("../../store/catalogs/dashboards");
const selectors_1 = require("../../store/catalogs/dashboards/selectors");
const rtk_utils_1 = require("../../store/rtk-utils");
const feature_flags_1 = require("../../../feature-flags");
const hooks_1 = require("../../../hooks");
const localization_1 = require("../../../localization");
const router_constants_1 = require("../../../router/router.constants");
const store_1 = require("../../../store");
const HLQATasksWidget = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const enableMultiFiltering = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.MultiFiltering);
    const excludedOperatorValues = (0, react_1.useMemo)(() => (enableMultiFiltering ? Array.from((0, ui_components_1.getPanelOnlyOperatorValues)()) : undefined), [enableMultiFiltering]);
    const dispatch = (0, rtk_utils_1.useAppDispatch)();
    const navigate = (0, react_router_1.useNavigate)();
    const [localSort, setLocalSort] = react_1.default.useState(null);
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProductTreeId = (0, store_1.useProductTreeId)();
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const { getSearchParamsString } = (0, query_params_1.useSearchParamsString)();
    const openTaskView = (0, react_1.useCallback)((row) => {
        const searchParams = getSearchParamsString({
            projectId: selectedProjectId,
            catalogId: selectedCatalogId,
            terminalNodeId: row.productTreeNodeId,
            attributeName: row.label,
        });
        navigate((0, router_constants_1.getEnrichAIPath)(router_constants_1.EnrichSection.HLQATaskView, searchParams), { relative: 'path' });
    }, [
        getSearchParamsString,
        navigate,
        selectedCatalogId,
        selectedProjectId,
    ]);
    const { columns, onCellEditStart } = (0, table_config_1.useHLQATasksColumns)({
        productTreeId: selectedProductTreeId,
        productTreeNodeId: productTreeRootNodeId,
        projectId: selectedProjectId,
        onViewTask: openTaskView,
    });
    const tableFilter = (0, selectors_1.usePriorityTasksTableFilter)();
    const tableSort = (0, selectors_1.usePriorityTasksTableSort)();
    const pageSize = (0, selectors_1.usePriorityTasksTablePageSize)();
    const { columnsOrder } = (0, selectors_1.usePriorityTasksTableDynamicColumns)();
    const areDashboardTasksQueryParamsReady = (0, use_dashboard_tasks_query_params_sync_1.useDashboardTasksQueryParamsSync)();
    const setPersistedColumnsOrder = (0, react_1.useCallback)((newColumnsOrder) => {
        dispatch(dashboards_1.dashboardsActions.setPriorityTasksTableDynamicColumns(selectedCatalogId, { columnsOrder: newColumnsOrder }));
    }, [dispatch, selectedCatalogId]);
    const { orderedColumns, onColumnOrderChange } = (0, use_columns_order_1.useColumnsOrder)(columns, columnsOrder, setPersistedColumnsOrder);
    const persistedPaginationState = (0, react_1.useMemo)(() => ({ pageSize }), [pageSize]);
    const initialPaginationModel = (0, react_1.useMemo)(() => ({ page: 0, pageSize }), [pageSize]);
    const setPersistedPaginationState = (0, react_1.useCallback)((paginationModel) => {
        if (paginationModel.pageSize !== pageSize) {
            dispatch(dashboards_1.dashboardsActions.setPriorityTasksTablePageSize(selectedCatalogId, paginationModel.pageSize));
        }
    }, [dispatch, selectedCatalogId, pageSize]);
    // Filtering
    const handleUpdateFilter = (0, react_1.useCallback)((model) => {
        if (!areDashboardTasksQueryParamsReady)
            return;
        const newTableFilter = (0, table_filter_1.buildFilterStateFromUIDataGridFilter)(model);
        dispatch(dashboards_1.dashboardsActions.setPriorityTasksTableFilter(selectedCatalogId, newTableFilter));
    }, [areDashboardTasksQueryParamsReady, dispatch, selectedCatalogId]);
    const persistedFilterData = (0, react_1.useMemo)(() => ({
        filter: (0, table_filter_1.parseTableFilterStateToDataGridFilter)(tableFilter),
    }), [tableFilter]);
    const { filterModel, setFilterModel, } = (0, ui_components_1.useFilter)({
        persistedState: persistedFilterData.filter,
        setPersistedState: handleUpdateFilter,
    });
    // Sorting
    const handleUpdateSort = (0, react_1.useCallback)((model) => {
        if (model.length === 0) {
            dispatch(dashboards_1.dashboardsActions.setPriorityTasksTableSort(selectedCatalogId, null));
            return;
        }
        const { field, sort } = model[0];
        // ✅ CLIENT SIDE SORT for reviewedBy
        if (field === 'reviewedBy') {
            setLocalSort({
                field,
                direction: sort,
            });
            return;
        }
        dispatch(dashboards_1.dashboardsActions.setPriorityTasksTableSort(selectedCatalogId, {
            key: field,
            direction: sort === 'asc'
                ? 0 /* SortDirection.Ascending */
                : 1 /* SortDirection.Descending */,
        }));
    }, [dispatch, selectedCatalogId]);
    const normalizedTableSort = (0, react_1.useMemo)(() => (0, utils_1.getNormalizedPriorityTasksSort)(tableSort), [tableSort]);
    const persistedSortData = (0, react_1.useMemo)(() => {
        if (!normalizedTableSort)
            return [];
        return [{
                field: normalizedTableSort.key,
                sort: normalizedTableSort.direction === 0 /* SortDirection.Ascending */ ? 'asc' : 'desc',
            }];
    }, [normalizedTableSort]);
    const { sortModel, setSortModel, } = (0, ui_components_1.useSorting)({
        persistedState: persistedSortData,
        setPersistedState: handleUpdateSort,
    });
    const apiFilter = (0, react_1.useMemo)(() => (0, utils_1.getPriorityTasksFilterDTO)(tableFilter), [tableFilter]);
    const apiSort = (0, react_1.useMemo)(() => {
        if (!tableSort)
            return [];
        // skip reviewedBy for API
        if (tableSort.key === 'reviewedBy') {
            return [];
        }
        return (0, utils_1.getPriorityTasksSortDTO)(tableSort);
    }, [tableSort]);
    const { processRowUpdate, processRowUpdateError } = (0, use_process_row_update_hook_1.useProcessRowUpdate)({
        filter: apiFilter,
        sort: apiSort,
        pageSize,
    });
    const { data, isLoading, error, refetch, pageInfo, totalCount, } = (0, client_1.useGetHLQATasks)({
        catalogId: selectedCatalogId,
        productTreeId: selectedProductTreeId,
        filter: apiFilter,
        sort: apiSort,
        pageSize,
        options: {
            skip: !areDashboardTasksQueryParamsReady,
        },
    });
    const { paginationModel, onPaginationModelChange, } = (0, table_pagination_1.useOffsetCursorPaginationAdapter)({
        refetch,
        totalCount,
        startCursor: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.startCursor,
        persistedState: persistedPaginationState,
        initialModel: initialPaginationModel,
        setPersistedState: setPersistedPaginationState,
    });
    const handleCellDoubleClick = (0, react_1.useCallback)((params) => {
        const clickedField = params.field;
        const isEditableColumn = columns.some((column) => column.field === clickedField && Boolean(column.editable));
        if (isEditableColumn)
            return;
        const allowedColumns = [
            constants_1.HLQATasksColumns.TerminalNode,
            constants_1.HLQATasksColumns.Attribute,
        ];
        if (!allowedColumns.includes(clickedField))
            return;
        const searchParams = getSearchParamsString({
            projectId: selectedProjectId,
            catalogId: selectedCatalogId,
            terminalNodeId: params.row.productTreeNodeId,
            attributeName: params.row.label,
        });
        navigate((0, router_constants_1.getEnrichAIPath)(router_constants_1.EnrichSection.HLQATaskView, searchParams), { relative: 'path' });
    }, [
        columns,
        getSearchParamsString,
        navigate,
        selectedCatalogId,
        selectedProjectId,
    ]);
    const tableData = (0, react_1.useMemo)(() => {
        let rows = data.map((item) => (Object.assign(Object.assign({}, item), { id: item.task, taskCount: item.taskCount && item.taskCount > 0 ? item.taskCount : null, reviewedBy: item.reviewedBy || [] })));
        if ((localSort === null || localSort === void 0 ? void 0 : localSort.field) === 'reviewedBy' && localSort.direction) {
            rows = [...rows].sort((a, b) => {
                var _a, _b;
                const aValue = (((_a = a.reviewedBy) === null || _a === void 0 ? void 0 : _a[0]) || '').toLowerCase();
                const bValue = (((_b = b.reviewedBy) === null || _b === void 0 ? void 0 : _b[0]) || '').toLowerCase();
                if (aValue < bValue)
                    return localSort.direction === 'asc' ? -1 : 1;
                if (aValue > bValue)
                    return localSort.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }
        return rows;
    }, [data, localSort]);
    const { selectionModel, setSelectionModel, selectedItemsCount, areAllItemsSelected, selectAll, resetSelection, isAtLeastOneItemSelected, } = (0, ui_components_1.useAdvancedSelection)({
        totalCount,
    });
    const selectedTaskNodesRef = react_1.default.useRef({});
    const selectedTaskNodesById = (0, react_1.useMemo)(() => tableData.reduce((acc, row) => {
        if (row.id && row.productLabelValidationId && row.productTreeNodeId) {
            acc[row.id] = {
                productLabelValidationId: row.productLabelValidationId,
                productTreeNodeId: row.productTreeNodeId,
            };
        }
        return acc;
    }, {}), [tableData]);
    const handleRowSelectionModelChange = (0, react_1.useCallback)((nextSelectionModel) => {
        const resolvedSelectionModel = typeof nextSelectionModel === 'function'
            ? nextSelectionModel(selectionModel)
            : nextSelectionModel;
        setSelectionModel(resolvedSelectionModel);
        if (resolvedSelectionModel.type !== 'include') {
            return;
        }
        const nextSelectionIds = new Set(Array.from(resolvedSelectionModel.ids, String));
        const nextSelectedTaskNodes = Object.assign({}, selectedTaskNodesRef.current);
        Object.keys(nextSelectedTaskNodes).forEach((id) => {
            if (!nextSelectionIds.has(id)) {
                delete nextSelectedTaskNodes[id];
            }
        });
        nextSelectionIds.forEach((id) => {
            if (!nextSelectedTaskNodes[id] && selectedTaskNodesById[id]) {
                nextSelectedTaskNodes[id] = selectedTaskNodesById[id];
            }
        });
        selectedTaskNodesRef.current = nextSelectedTaskNodes;
    }, [selectedTaskNodesById, selectionModel, setSelectionModel]);
    const getSelectedTaskNodes = (0, react_1.useCallback)(() => Array.from(selectionModel.ids, String)
        .map((id) => selectedTaskNodesRef.current[id])
        .filter((taskNode) => Boolean(taskNode)), [selectionModel.ids]);
    const { isBulkUpdateLoading, isBulkEditModalOpen, handleOpenBulkEditModal, handleCloseBulkEditModal, handleSaveBulkEditModal, } = (0, use_hlqa_tasks_bulk_actions_hook_1.useHLQATasksBulkActions)({
        catalogId: selectedCatalogId,
        productTreeId: selectedProductTreeId,
        apiFilter,
        totalCount,
        areAllItemsSelected,
        getSelectedTaskNodes,
        resetSelection,
        refetch,
    });
    const dataGridLoadingState = (0, use_table_loading_state_1.useTableLoadingState)({
        requestVariables: { catalogId: selectedCatalogId, productTreeId: selectedProductTreeId },
        isLoading,
        hasError: Boolean(error),
    });
    const dataGridInitialState = (0, react_1.useMemo)(() => ({
        pinnedColumns: {
            left: [ui_components_1.GRID_CHECKBOX_SELECTION_COL_DEF.field, constants_1.HLQATasksColumns.View],
        },
    }), []);
    return (react_1.default.createElement(hlqa_tasks_widget_styles_1.StyledHLQATaskViewWidget, { title: t({ key: 'TASKS' }) }, react_1.default.createElement(ui_components_1.Typography, { className: "total-results", color: "textSecondary" }, t({ key: 'TOTAL_RESULTS', values: { totalCount: totalCount !== null && totalCount !== void 0 ? totalCount : 0 } })), isAtLeastOneItemSelected && (react_1.default.createElement(components_1.HLQATasksBulkSelectionPanel, { totalCount: totalCount !== null && totalCount !== void 0 ? totalCount : 0, selectedItemsCount: selectedItemsCount, areAllTasksSelected: areAllItemsSelected, onSelectAllTasks: selectAll, onResetSelectedTasks: resetSelection, onEdit: handleOpenBulkEditModal })), react_1.default.createElement(components_1.HLQATasksBulkEditModal, { projectId: selectedProjectId, open: isBulkEditModalOpen, onClose: handleCloseBulkEditModal, onSave: handleSaveBulkEditModal, isSaving: isBulkUpdateLoading }), react_1.default.createElement(ui_components_1.AdvancedDataGrid, { columns: orderedColumns, rows: dataGridLoadingState.hasSettled ? tableData : [], loading: !areDashboardTasksQueryParamsReady || dataGridLoadingState.loading, rowCount: dataGridLoadingState.hasSettled ? (totalCount !== null && totalCount !== void 0 ? totalCount : 0) : 0, checkboxSelection: true, checkboxSelectionVisibleOnly: true, keepNonExistentRowsSelected: true, hideFooterSelectedRowCount: true, disableRowSelectionOnClick: true, onCellDoubleClick: handleCellDoubleClick, onCellEditStart: onCellEditStart, onColumnOrderChange: onColumnOrderChange, initialState: dataGridInitialState, getRowId: (row) => row.id, rowSelectionModel: selectionModel, onRowSelectionModelChange: handleRowSelectionModelChange, processRowUpdate: processRowUpdate, onProcessRowUpdateError: processRowUpdateError, filterModel: filterModel, onFilterModelChange: setFilterModel, filterMode: "server", sortingMode: "server", sortModel: sortModel, onSortModelChange: setSortModel, showToolbar: true, paginationMode: "server", pagination: true, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, pageSizeOptions: client_constants_1.PAGE_SIZES, slots: Object.assign({ basePagination: ui_components_1.PaginationContainer, noRowsOverlay: error ? table_error_overlay_1.TableErrorOverlay : ui_components_1.DataGridNoResults, columnHeaderFilterIconButton: ui_components_1.FilterContainer, toolbar: components_1.HLQAToolbarLayout }, (enableMultiFiltering && { filterPanel: ui_components_1.MultiFilterPanel })), slotProps: Object.assign(Object.assign({ noRowsOverlay: { noResultsText: (error === null || error === void 0 ? void 0 : error.message) || t({ key: 'NO_DATA_AVAILABLE' }) }, basePagination: {
                enablePageSizeSelectorControl: true,
                enablePageNavigation: true,
                enableEdgeButtons: true,
                rowsPerPageOptions: client_constants_1.PAGE_SIZES,
            } }, (excludedOperatorValues && {
            columnHeaderFilterIconButton: { excludedOperatorValues },
        })), { toolbar: { enableMultiFiltering } }), showCellVerticalBorder: true, showColumnVerticalBorder: true, enableVirtualization: true })));
};
exports.HLQATasksWidget = HLQATasksWidget;
